import React from "react";
import UseIconHooks from "../hooks/useIconHooks";
import { IconButton } from "@mui/material";
import { containerSideBar } from "../global/styles";
import { useSelector } from "react-redux";
import colors from "../../config/colors";

const SideBar = () => {
  const isUltra = useSelector((state) => state.afiliado.infoAfiliado.isUltra);
  const ultraDarkMode = useSelector((state) => state.afiliado.infoAfiliado.ultraDarkMode);
  const isDark = isUltra && ultraDarkMode;
  const isUltraLight = isUltra && !ultraDarkMode;

  const iconStyle = isDark
    ? { color: colors.ultraAccentLight }
    : isUltraLight
      ? { color: colors.ulAccent }
      : undefined;

  return (
    <div style={{
      ...containerSideBar,
      backgroundColor: isDark ? colors.ultraMid : colors.white,
      border: isDark ? `1px solid ${colors.ultraAccentBorder}` : isUltraLight ? `1px solid ${colors.ulBorder}` : undefined,
      transition: 'background-color 0.45s ease',
    }}>
      <div style={{ marginBottom: -20 }}>
        <IconButton size='large' href='https://www.facebook.com/ARSSeNaSaRD' target='_blank'>
          {UseIconHooks("facebook", { fontSize: "large", color: isUltra ? undefined : "success", style: iconStyle })}
      </IconButton>
      </div>
      <div style={{ marginBottom: -20 }}>
        <IconButton size='large' href='https://twitter.com/arssenasard' target='_blank'>
          {UseIconHooks("x", { fontSize: "large", color: isUltra ? undefined : "success", style: iconStyle })}
      </IconButton>
      </div>
      <div style={{ marginBottom: -20 }}>
        <IconButton size='large' href='https://www.instagram.com/arssenasard/' target='_blank'>
          {UseIconHooks("instagram", { fontSize: "large", color: isUltra ? undefined : "success", style: iconStyle })}
      </IconButton>
      </div>
      <div>
        <IconButton size='large' href='https://www.youtube.com/user/ARSSeNaSa' target='_blank'>
          {UseIconHooks("youtube", { fontSize: "large", color: isUltra ? undefined : "success", style: iconStyle })}
        </IconButton>
      </div>
    </div>
  );
};

export default SideBar;
